import { Collapse } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import CheckSvg from '../../../../assets/images/check-gray.svg'
import ClockSvg from '../../../../assets/images/clock-icon-purple.svg'
import CrossSvg from '../../../../assets/images/cross-red.svg'
import HouseSvg from '../../../../assets/images/house-icon.svg'
import SearchSvg from '../../../../assets/images/lupa-white.svg'
import CircleOff from '../../../../assets/images/mdi_circle-off-outline.svg'
import CustomizedBtn from '../../../components/Admin/CustomizedBtn'
import CustomTable from '../../../components/Admin/CustomTable'
import Layout from '../../../components/Admin/Layout'
import RadioOption from '../../../components/Admin/RadioOption'
import SearchButton from '../../../components/Admin/SearchButton'
import SearchText from '../../../components/Admin/SearchText'
import SearchWarning from '../../../components/Admin/SearchWarning'
import Button from '../../../components/shared/Button'
import Loading from '../../../components/shared/Loading'
import MessageModal from '../../../components/shared/MessageModal'
import useLocalStorage from '../../../hooks/useLocalStorage'
import AdminService from '../../../services/AdminServices'
import CustomSelect from '../../../components/shared/CustomSelect'
import { FormControl, InputLabel, Select, MenuItem, FormHelperText, makeStyles } from '@material-ui/core';

import './Annulment.scss'


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));


const superState = {
  reason: { id: 0, name: '' },
  cancelCuds: []
}

const Annulment = () => {
  // TABLE STATES
  const [rows, setRows] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);
  // const [total, setTotal] = useState(10);
  // const [perPage, setPerPage] = useState(5);
  // TABLE STATES
  const [showFilters, setShowFilters] = useState(true)
  const [invalidOc, setInvalidOc] = useState(false)
  const [invalidDni, setInvalidDni] = useState(false)
  const [checkedOption, setCheckedOption] = useState(1)
  const [notFounded, setNotFounded] = useState('')
  const [textSearch, setTextSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [loadingScreen, setLoadingScreen] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [selectedCud, setSelectedCud] = useState('')
  const [selectedOc, setSelectedOc] = useState('')
  const [originOption, setOriginOption] = useState('ripley')
  const [userappret] = useLocalStorage('userappret');
  const [disableCancelButton, setDisableCancelButton] = useState(true)
  const [reasons, setReasons] = useState([])
  const [reason, setReason] = React.useState('');
  const classes = useStyles();

  useEffect(() => {
    async function fetchData() {
      const data = await AdminService.getReasons()
      setReasons(data)
    }
    fetchData()
  }, [])

  const handleSelectOption = (e) => {
    setReason(e.target.value)
  }

  const handleCanceldCuds = ({ id, state, checked }) => {
    console.log("test", id, state, checked)
    if (checked) {
      const find = superState.cancelCuds.filter(cud => cud.id == id)
      if (find.length == 0) {
        superState.cancelCuds.push({ id, state })
      }
    } else {
      superState.cancelCuds = superState.cancelCuds.filter(item => item.id != id)
    }
    if (superState.cancelCuds.length == 0) {
      setDisableCancelButton(true)
    } else {
      setDisableCancelButton(false)
    }
  }

  const formatState = (state) => {
    switch (state.toUpperCase()) {
      case 'ENTREGADO': return (
        <>
          <img src={CheckSvg} alt='check' />
          <span style={{ color: '#A0A2A6', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >{state}</span>
        </>
      )
      case 'DEVUELTO': return (
        <>
          <img src={CheckSvg} alt='check' />
          <span style={{ color: '#A0A2A6', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >{state}</span>
        </>
      )
      case 'RETURNED': return (
        <>
          <img src={CheckSvg} alt='check' />
          <span style={{ color: '#A0A2A6', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >Devuelto</span>
        </>
      )
      case 'SIN RECEPCIONAR': return (
        <>
          <img src={ClockSvg} alt='clock' />
          <span style={{ color: '#9240C9', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >{state}</span>
        </>
      )
      case 'UNRECEIVED': return (
        <>
          <img src={ClockSvg} alt='clock' />
          <span style={{ color: '#9240C9', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >Sin recepcionar</span>
        </>
      )
      case 'POR RETORNAR': return (
        <>
          <img src={ClockSvg} alt='clock' />
          <span style={{ color: '#9240C9', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >{state}</span>
        </>
      )
      case 'EXPIRADO': return (
        <>
          <img src={CrossSvg} alt='cross' />
          <span style={{ color: '#FF6868', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >{state}</span>
        </>
      )
      case 'ANULADO / RECEPCIONADO': return (
        <>
          {/*<img src={CircleOff} alt='CircleOff' />*/}
          <span style={{ color: '#EE2737', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >{state}</span>
        </>
      )
      case 'ANULADO / SIN RECEPCIONAR': return (
        <>
          {/*<img src={CircleOff} alt='CircleOff' />*/}
          <span style={{ color: '#EE2737', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold', textAlign: 'center' }} >{state}</span>
        </>
      )
      case 'SIN RECEPCIONAR NE': return (
        <>
          <img src={CircleOff} alt='CircleOff' />
          <span style={{ color: '#EE2737', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >{state}</span>
        </>
      )
      case 'POR RETORNAR NE': return (
        <>
          <img src={CircleOff} alt='CircleOff' />
          <span style={{ color: '#EE2737', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >{state}</span>
        </>
      )
      case 'CANCELED': return (
        <>
          <img src={ClockSvg} alt='clock' />
          <span style={{ color: '#9240C9', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >Anulado</span>
        </>
      )
      case 'TORETURN': return (
        <>
          <img src={ClockSvg} alt='clock' />
          <span style={{ color: '#9240C9', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >Por retornar</span>
        </>
      )
      case 'RECEIVED': return (
        <>
          <img src={HouseSvg} alt='house' />
          <span style={{ color: '#F2AD4B', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >Recepcionado</span>
        </>
      )
      default: return (
        <>
          <img src={HouseSvg} alt='house' />
          <span style={{ color: '#F2AD4B', textTransform: 'capitalize', marginLeft: '.2em', fontFamily: 'OpenSansSemibold' }} >{state}</span>
        </>
      )
    }
  }

  const formattedCuds = ({ cuds, oc, pickupPoint, originType, sign }) => {
    const mycuds = originType === 'ripley'
      ? cuds.map(cud => {
        return ({
          cud: cud.cudNumber,
          pickupPoint: `${pickupPoint}`,
          state: `${cud.estado}`,
          action: `${cud.cudNumber}@${cud.estado}@${oc}`,
          sku: cud.ean,
          description: cud.description,
          reason: cud.reason ? `(${cud.reason})` : ''
        })
      })
      : cuds.map(cud => {
        return ({
          cud: cud.suborder,
          pickupPoint: `${pickupPoint}`,
          state: sign ? 'ENTREGADO' : cud.skus[0].sku.status,
          action: `${cud.suborder}@${sign ? 'ENTREGADO' : cud.skus[0].sku.status}@${oc}`,
          // state: sign ? 'ENTREGADO' : cud.status ,
          // action: `${cud.suborder}@${sign ? 'ENTREGADO' : cud.status}@${oc}`,
          skus: cud.skus,
          description: cud.description,
        })
      })
    mycuds.sort((a, b) => {
      if (a.cud > b.cud) {
        return 1;
      }
      if (a.cud < b.cud) {
        return -1;
      }
      return 0;
    })
    return mycuds
  }

  const formatOcs = ocs => {
    return (ocs.map(oc => ({
      groupName: oc.orderNumber,
      rows: formattedCuds({ cuds: oc.cuds, oc: oc.orderNumber, pickupPoint: oc.title, originType: oc.originType, sign: oc.sign })
    })))
  }

  const fetchOcs = async () => {
    try {
      setRows([])
      setNotFounded(textSearch)
      setLoading(true)
      setInvalidOc(false)
      setInvalidDni(false)
      const rows = await AdminService.getFullCuds({ textSearch, checkedOption, originOption })
      setLoading(false)
      if (rows.length > 0) {
        const formattedRows = formatOcs(rows)
        console.log('formatted rows', formattedRows);
        setRows(formattedRows)
        setShowFilters(false);
      } else {
        checkedOption === 2 ? setInvalidDni(true) : setInvalidOc(true)
      }
    } catch (e) {
      setLoading(false)
      console.log('Error: ', e)
    }
  }

  const formatGroupHeader = groupName => {
    return (
      <span style={{ fontSize: '16px', color: '#58595B', marginRight: 'auto', display: 'block' }}>Pedido N° <span style={{ color: '#333333', fontFamily: 'OpenSansSemibold' }}>{groupName}</span></span>
    )
  }
  const setModalVariables = (cud, oc) => {
    setSelectedCud(cud)
    setSelectedOc(oc)
    setShowModal(true)
  }

  const handleCancelCud = async cud => {
    try {
      setLoadingScreen(true)
      await AdminService.cancelCud(cud, userappret.username)
      const rows = await AdminService.getFullCuds({ textSearch, checkedOption, originOption })
      console.log(rows);
      const formattedRows = formatOcs(rows)
      setRows(formattedRows)
      setShowModal(false)
      setLoadingScreen(false)
    } catch (e) {
      setLoadingScreen(false)
    }
  }



  const saveCancelCuds = async (cuds, reason) => {
    const ids = cuds.map(cud => cud.id)
    console.log("ids", ids)
    const orderNumbers = rows.map(row => row.groupName)
    try {
      setLoadingScreen(true)
      await AdminService.cancelCuds(ids, originOption, orderNumbers, reason, userappret.username)
      const rows = await AdminService.getFullCuds({ textSearch, checkedOption, originOption })
      const formattedRows = formatOcs(rows)
      setReason('')
      setRows(formattedRows)
      setShowModal(false)
      setLoadingScreen(false)
      superState.cancelCuds = []
      setDisableCancelButton(true)
      console.log('end!')
    } catch (e) {
      setLoadingScreen(false)
      console.log('catch!')
    }
  }

  const formatAction = action => {
    const [cud, status, oc] = action.split('@')
    return (
      <CustomizedBtn
        filled
        margin='0'
        onClick={() => setModalVariables(cud, oc)}
        borderRadius='4px'
        disableCancelButtond={!(status === 'Recepcionado' || status === 'received')}
        disableCancelButtondColor='#CCCCCC'
        height='2.5em'
        size='small'
      >
        <span style={{ textTransform: 'none', margin: '0', fontFamily: 'OpenSansSemibold' }}>Anular</span>
      </CustomizedBtn>
    )
  }
  const columns = [
    { id: 'cud', label: (originOption === 'ripley') ? 'CUD' : 'Sub-pedido' },
    { id: 'pickupPoint', label: 'Punto de retiro', minWidth: 170 },
    { id: 'state', label: 'Estado', format: formatState, minWidth: 170 },
    // { id: 'action', label: 'Acción', format: formatAction, },
    { id: 'sku', label: 'EAN', textAlign: 'center' },
    { id: 'description', label: 'Descripción', minWidth: 400 },
  ];
  const columnsForMkp = [
    { id: 'cud', label: (originOption === 'ripley') ? 'CUD' : 'Sub-pedido' },
    { id: 'pickupPoint', label: 'Punto de retiro', minWidth: 170 },
    { id: 'state', label: 'Estado', format: formatState, minWidth: 170 },
    // { id: 'action', label: 'Acción', format: formatAction, },
    { id: 'skus', label: ' ver EANS', type: 'skus', minWidth: 100 },
  ];
  const getTotal = rows => {
    let sum = 0
    for (const row of rows) {
      sum += row.rows.length
    }
    return sum
  }

  const cleanFilters = () => {
    setShowFilters(true)
    setTextSearch('')
    setOriginOption('ripley')
    setCheckedOption(1)
    setRows([])
  }

  return (
    <Layout title='Post-venta'>
      <Loading visible={loadingScreen} />
      <MessageModal
        visible={showModal}
        type={14}
        txtBtn1='Volver'
        onClickBtn1={() => {
          setShowModal(false)
          setReason("")
        }}
        txtBtn2='Confirmar'
        onClickBtn2={() => saveCancelCuds(superState.cancelCuds, reason)}
        disabled={reason ? false : true}
        title='¿Seguro/a que deseas anular CUDS?'
      >
        <div className='annulment-modal'>
          <div>
            <p><span>Vas a anular</span></p>
            {
              superState.cancelCuds.map(cud => <p><span>CUD Nº {cud.id}</span></p>)
            }
            <FormControl className={classes.formControl}>
              <InputLabel shrink id="demo-simple-select-placeholder-label-label">Motivo</InputLabel>
              <Select
                labelId="demo-simple-select-placeholder-label-label"
                id="demo-simple-select-placeholder-label"
                // value={reasons.length > 0 ? reasons[0].name : ''}
                // value={reasons[0] && reasons[0].name}
                value={reason}
                displayEmpty
                className={classes.selectEmpty}
                onChange={handleSelectOption}
              >
                <MenuItem disabled value="">
                  <em>Seleccionar...</em>
                </MenuItem>
                {
                  reasons.map(({ id, name }) => {
                    // console.log("cancelCudss", superState.cancelCuds)
                    const receives = superState.cancelCuds.filter(cud => cud.state == 'Recepcionado')
                    const flag = receives.length > 0
                    if (id === 3 && flag) {
                      return <MenuItem key={id} disabled value={name}>{name}</MenuItem>
                    }
                    return <MenuItem key={id} value={name}>{name}</MenuItem>
                  })
                }
              </Select>
            </FormControl>
          </div>
        </div>
      </MessageModal>
      {/* <h3 className='annulment-container-title'>Anulación de pedidos</h3> */}
      {
        !showFilters &&
        // <div className='evidences-container-button-newSearch'>
        //   <Button
        //     text='nueva búsqueda'
        //     image={SearchSvg}
        //     onClick={cleanFilters}
        //   />
        // </div>
        <div className='evidences-container-button-newSearch'>
          {
            disableCancelButton ?
              <div>
                <Button
                  text='nueva búsqueda'
                  image={SearchSvg}
                  onClick={cleanFilters}
                />
              </div> :
              <div>
                <Button
                  text='anular'
                  // disableCancelButtond={true}
                  // image={SearchSvg}
                  onClick={() => setShowModal(true)}
                />
              </div>
          }

        </div>


      }
      <div className='annulment-container-searchbox'>
        {/* <div className={`annulment-container-searchbox-head ${showFilters ? 'showing' : null}`} onClick={() => setShowFilters(!showFilters)}> */}
        <div className={`annulment-container-searchbox-head ${showFilters ? 'showing' : null}`} onClick={() => disableCancelButton ? setShowFilters(!showFilters) : null}>

          <p>Buscar pedidos</p>
          <div>
            <img className={`${showFilters ? 'showing' : null}`} src={require('../../../../assets/images/arrow-orange.svg')} alt='arrow-org' />
          </div>
        </div>
        <Collapse in={showFilters}>
          <div className='annulment-container-searchbox-body'>
            <p>Origen del pedido</p>
            <div className='annulment-container-searchbox-body-options'>
              <RadioOption
                label='Productos Ripley'
                isChecked={originOption === 'ripley'}
                onClick={() => {
                  setRows([])
                  setOriginOption('ripley')
                  setTextSearch("");
                  setCheckedOption(1);
                }}
                />
              <RadioOption
                label='Marketplace'
                isChecked={originOption === 'mkp'}
                onClick={() => {
                  setRows([])
                  setOriginOption('mkp')
                  setTextSearch("");
                  setCheckedOption(1);
                }}
              />
            </div>
            <p>Buscar por</p>
            <div className='annulment-container-searchbox-body-options'>
              <RadioOption
                label='Orden de compra'
                isChecked={checkedOption === 1}
                onClick={() => {
                  setInvalidOc(false)
                  setInvalidDni(false)
                  setCheckedOption(1)
                }}
              />
              <RadioOption
                label='DNI del titular'
                isChecked={checkedOption === 2}
                onClick={() => {
                  setInvalidOc(false)
                  setInvalidDni(false)
                  setCheckedOption(2)
                }}
              />

              {/* Gonzalo Toledo */}
              {
                originOption === 'ripley' &&
                <RadioOption
                  label='Número de CUD'
                  isChecked={checkedOption === 3}
                  onClick={() => {
                    setInvalidOc(false)
                    setInvalidDni(false)
                    setCheckedOption(3)
                  }}
                />}
            </div>
            <div className='annulment-container-searchbox-body-search'>
              <SearchText
                value={textSearch}
                onChange={text => {
                  setInvalidOc(false)
                  setInvalidDni(false)
                  setTextSearch(text)
                }}
              />
            </div>

            <div className='annulment-container-searchbox-body-button'>
              <SearchButton
                disabled={textSearch.length < 8 ? true : false}
                text='BUSCAR PEDIDOS!'
                onClick={() => fetchOcs()}
              />
            </div>
          </div>
        </Collapse>
      </div>
      {rows.length > 0 &&
        <>
          <div className={`annulment-container-report-table ${showFilters ? 'minHeight' : ''}`}>
            <CustomTable
              grouped={{
                colSpan: 6,
                format: formatGroupHeader
              }}
              pagination={false}
              columns={(originOption === 'ripley') ? columns : columnsForMkp}
              rows={rows}
              // onChangeNumElem={(num) => onChangePerPage(num)}
              total={getTotal(rows)}
              // checkbox={true}
              // currentPage={currentPage}
              // changePage={onChangePage}
              // perPage={perPage}
              // onChangePerPage={(e) => setPerPage(e.target.value)}
              // totalPages={totalPages}
              handleCanceldCuds={handleCanceldCuds}
            />
          </div>
        </>
      }
      {invalidDni && (
        <div className='annulment-container-warning'>
          <SearchWarning
            title='Titular no encontrado'
            description={`El cliente titular con DNI ${notFounded} no tiene pedidos para retirar en Tambo.`}
            onClose={() => setInvalidDni(false)}
          />
        </div>
      )}
      {invalidOc && (
        <div className='annulment-container-warning'>
          <SearchWarning
            title='Pedido no encontrado'
            description={`La orden de compra Nº ${notFounded} no está cargada en Tambo. Valida el pedido en Big Ticket.`}
            onClose={() => setInvalidOc(false)}
          />
        </div>
      )}
      <Collapse in={loading}>
        <div className='annulment-container-loading'>
          <img src={require('../../../../assets/images/loading.gif')} className='cargando' alt='loading' />
          <p>Buscando pedidos</p>
        </div>
      </Collapse>
    </Layout>
  )
}

export default Annulment
